module.exports = __webpack_public_path__ + "img/NoiseAware_Logo_HRZ_Cream.e987998b.png";